import SiteHeader from "../../features/navigation/SiteHeader";

const Header = () => <SiteHeader />;

export default Header;
